
import { DateUtil } from "../common/date";
import { Group } from "../group/group.model";


export enum UserStatusType {
    InactiveOrDisabled = 0,
    Active = 1,
    CompanyLockedOutByAlarmNet = 2
}

export class UserLoginGroup {

    public LoginID: number = 0;
    public Group: Group;
    public CEID: number = 0;
    public CompanyName: string;
    public EmployeeID: string;
    public IsActive: UserStatusType;
    public CreatedBy: number;
    public ModifiedDate: Date | string = "";

    constructor(userLoginGroup: UserLoginGroup) {
        this.CEID = userLoginGroup.CEID || 0;
        this.CompanyName = userLoginGroup.CompanyName || "";
        this.EmployeeID = userLoginGroup.EmployeeID || "";
        this.IsActive = userLoginGroup.IsActive || UserStatusType.InactiveOrDisabled;
        this.CreatedBy = userLoginGroup.CreatedBy || 0;
        this.ModifiedDate = DateUtil.ConvertToLocalTimeZone(userLoginGroup.ModifiedDate);

        if (userLoginGroup.Group)
            this.Group = new Group(userLoginGroup.Group);
        else
            this.Group = new Group({} as Group);
    }


}